// Configuração centralizada da API
// Usa variáveis de ambiente com fallback para desenvolvimento

const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:5285/api";

export const config = {
  api: {
    baseURL: API_BASE_URL,
    timeout: 30000, // 30 segundos
    retries: 3,
  },
  app: {
    name: "Finance Dashboard",
    version: "1.0.0",
    environment: import.meta.env.MODE || "development",
  },
  features: {
    enableCache: true,
    enableAnalytics: import.meta.env.PROD,
  },
} as const;

export default config;
